import React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
import FooterLayout from 'layouts/FooterLayout';
import Logo from 'logos/Logo';
import { computer, landing } from 'images';
import { useTranslation } from 'react-i18next';
import LocaleButton from 'components/LocaleButton';

const PREFIX = 'LandingPage';

const classes = {
  root: `${PREFIX}-root`,
  toolbar: `${PREFIX}-toolbar`,
  toolbarButtons: `${PREFIX}-toolbarButtons`,
  red: `${PREFIX}-red`,
  green: `${PREFIX}-green`,
  appBar: `${PREFIX}-appBar`,
  appBarSpacer: `${PREFIX}-appBarSpacer`,
  titleSpacer: `${PREFIX}-titleSpacer`,
  contentContainer: `${PREFIX}-contentContainer`,
  content: `${PREFIX}-content`,
  leftContent: `${PREFIX}-leftContent`,
  rightContent: `${PREFIX}-rightContent`,
  paper: `${PREFIX}-paper`,
  fixedHeight: `${PREFIX}-fixedHeight`,
  title1: `${PREFIX}-title1`,
  title2: `${PREFIX}-title2`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    minWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
  },

  [`& .${classes.toolbar}`]: {
    display: 'flex',
    '& > *': {
      flex: 1
    },
  },

  [`& .${classes.toolbarButtons}`]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *': {
      marginLeft: theme.spacing(2),
    },
  },

  [`& .${classes.red}`]: {
    backgroundColor: red,
  },

  [`& .${classes.green}`]: {
    backgroundColor: green,
  },

  [`& .${classes.appBar}`]: {
    zIndex: theme.zIndex.drawer + 1,
  },

  [`& .${classes.appBarSpacer}`]: {
    minHeight: 120,
  },

  [`& .${classes.titleSpacer}`]: {
    minHeight: 20,
  },

  [`& .${classes.contentContainer}`]: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  [`& .${classes.content}`]: {
    flex: 1,
    margin: 'auto',
    maxWidth: 1600,
    paddingBottom: 30,
    paddingLeft: 100,
    paddingRight: 100,
    display: 'flex',
  },

  [`& .${classes.leftContent}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  [`& .${classes.rightContent}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  [`& .${classes.paper}`]: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },

  [`& .${classes.fixedHeight}`]: {
    height: 240,
  },

  [`& .${classes.title1}`]: {
    marginLeft: 40,
    fontWeight: 'bolder',
    margin: 0,
    lineHeight: 1.1,
    color: red,
  },

  [`& .${classes.title2}`]: {
    marginLeft: 40,
    fontWeight: 'bolder',
    lineHeight: 1.1,
    margin: 0,
    color: blue
  }
}));

const red = '#FF75A8';
const green = '#26C9A8';
const blue = '#3544D0';

interface Login {
  (): void;
}

interface Props {
  login?: Login;
  children?: React.ReactNode;
}

export default function LandingPage(props: Props): JSX.Element {

  const { login, children } = props;
  const { t } = useTranslation('default');

  return (
    <Root className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div>
            <Logo color="white" height={40}/>
          </div>
          <div className={classes.toolbarButtons}>
            <LocaleButton />
            {/* <ColorButton variant="contained" color="primary" className={classes.red} > Subscribe </ColorButton> */}
            <Button variant="contained" color="primary" className={classes.green} onClick={login} >{t('login')}</Button>
          </div>
        </Toolbar>
      </AppBar>
      <main className={classes.contentContainer}>
        <div className={classes.appBarSpacer} />
        <div>
          {children}
        </div>
        <div className={classes.content}>
          <div className={classes.leftContent}>
            <div>
              <h1 className={classes.title1}>{t('build your company')}</h1>
              <h1 className={classes.title1}>{t('tradability score')}</h1>
              <div className={classes.titleSpacer} />
              <h2 className={classes.title2}>{t('check your score')}</h2>
              <h2 className={classes.title2}>{t('boost your score')}</h2>
              <div className={classes.titleSpacer} />
              <div className={classes.titleSpacer} />
              <img width="100%" src={computer} alt="computer" />
            </div>
          </div>
          <div className={classes.rightContent}>
            <img width="100%" src={landing} alt="computer" />
          </div>
        </div>
        <FooterLayout />
      </main>
    </Root>
  );
}
